import Pusher from 'pusher-js';

export default function usePusher( channel_id, showModal ) {
    Pusher.logToConsole = true;
    console.log('using channel_id :>> ', channel_id);

    const pusher = new Pusher('136639a2ab92c53e9eab', {
        cluster: 'eu',
    });

    const channel = pusher.subscribe(channel_id);

    channel.bind('payment.accepted', (data) => {
        console.log('data :>> ', data);
        showModal( true);
    
    });

    channel.bind('payment.refused', (data) => {
        console.log('data :>> ', data);
        showModal(false);
    });
}
